
webpack.register(
    'blocks/dropdown/dropdown',
    function() {
        return import('blocks/dropdown/dropdown');
    },
    true
);